import { PhotoConcerne } from './photo-concerne';

export class Photo {

    id: string;
    file_name: string;
    name: string;
    mime_type: string;
    icon_class: string;
    file_size: string;
    content: string;
    date_commit: string;
    agence_bureaux_id: string;
    title: string;
    titre: string;
    url: string;
    thumb_url: string;
    logo_url: string;
    path: string;
    selected: boolean;
    activated: string;
    concerne: PhotoConcerne;
    published: string;
    order: string;
    random: any;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id                 = data['id'] ? data['id'] : null;
        this.file_name          = data['file_name'] ? data['file_name'] : null;
        this.name               = data['name'] ? data['name'] : null;
        this.mime_type          = data['mime_type'] ? data['mime_type'] : null;
        this.icon_class         = data['icon_class'] ? data['icon_class'] : null;
        this.file_size          = data['file_size'] ? data['file_size'] : null;
        this.content            = data['content'] ? data['content'] : null;
        this.date_commit        = data['date_commit'] ? data['date_commit'] : null;
        this.agence_bureaux_id  = data['agence_bureaux_id'] ? data['agence_bureaux_id'] : null;
        this.title              = data['title'] ? data['title'] : null;
        this.titre              = data['titre'] ? data['titre'] : null;
        this.url                = data['url'] ? data['url'] : null;
        this.thumb_url          = data['thumb_url'] ? data['thumb_url'] : null;
        this.logo_url           = data['logo_url'] ? data['logo_url'] : null;
        this.path               = data['path'] ? data['path'] : null;
        this.concerne           = data['concerne'] ? new PhotoConcerne(data['concerne']) : new PhotoConcerne();
        this.published          = data['published'] ? data['published'] : null;
        this.order              = data['order'] ? data['order'] : null;
        this.selected           = data['selected'] ? data['selected'] : false;
        this.activated          = data['activated'] ? data['activated'] : 'out';
        this.random             = data['random'] ? data['random'] : this.generateRandom();
    }

    isPdf() {
        let isPdf = false;
        switch (this.mime_type) {
            case 'application/pdf':
                isPdf = true;
                break;
            default:
                isPdf = false;
                break;
        }

        return isPdf;
    }

    isImage() {
        let isImg = false;
        switch (this.mime_type) {
            case 'image/jpeg':
            case 'image/png':
            case 'application/octet-stream':
                isImg = true;
                break;
            default:
                isImg = false;
                break;
        }

        return isImg;
    }

    // Utilisé pour afficher l'url de la photo sans la conserver dans le cache
    generateRandom(min = 0, max = 100000) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

}
